import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const productsModelName = searchParams.get('model');
    useEffect(() => {
        const setTitleByPathname = (pathname) => {
            if (pathname === "/") {
                document.title = "Traflux";
            } else if (pathname === "/giris-yap") {
                document.title = "Giriş Yap | Traflux";
            } else if (pathname === "/sifremi-unuttum") {
                document.title = "Şifremi Unuttum | Traflux";
            } else if (pathname === "/sifremi-sifirla") {
                document.title = "Şifre Yenileme | Traflux";
            } else if (pathname === "/kayit-ol") {
                document.title = "Kayıt Ol | Traflux";
            } else if (pathname === "/urunler" && productsModelName == "KASA") {
                document.title = "Kasalar | Traflux";
            } else if (pathname === "/urunler" && productsModelName == "PERVAZ") {
                document.title = "Pervazlar | Traflux";
            } else if (pathname === "/urunler" && (productsModelName == null || productsModelName == "" || productsModelName == undefined)) {
                document.title = "Ürünler | Traflux";
            } else if (pathname === "/urunler") {
                document.title = ` ${productsModelName} Kapılar | Traflux`;
            }
            else if (pathname.startsWith("/urun/")) {
                const oneProductFullModelName = pathname.split("/")[2];
                const oneProductModelName = oneProductFullModelName.split("-")[0]
                if (oneProductModelName == "KASA") {
                    document.title = `${oneProductFullModelName} Kasa Modeli | Traflux`;
                }
                else if (oneProductModelName == "PERVAZ") {
                    document.title = `${oneProductFullModelName} Pervaz Modeli | Traflux`;
                }
                else {
                    document.title = `${oneProductFullModelName} Kapı Modeli | Traflux`;
                }
            }
            else if (pathname === "/biz-kimiz") {
                document.title = "Biz Kimiz | Traflux";
            }
            else if (pathname === "/surecler") {
                document.title = "Üretim Süreçlerimiz | Traflux";
            }
            else if (pathname === "/referanslar") {
                document.title = "Referanslarımız | Traflux";
            }
            else if (pathname === "/e-katalog") {
                document.title = "E-Katalog | Traflux";
            }
            else if (pathname === "/iletisim") {
                document.title = "İletişim | Traflux";
            }
            else if (pathname === "/trafik-akisi") {
                document.title = "Trafik Akışı | Traflux";
            }
            else {
                document.title = "Sayfa Bulunamadı | Traflux";
            }
        };
        setTitleByPathname(location.pathname);
    }, [location]);

    return null
}

export default PageTitle